import { Country } from '@/interfaces/country.interface';

export const shortDateFormat = 'YYYY-MM-DD';

export const VALIDATION_RULES = {
  required: [
    (v: string) => !!v || 'Field is required',
    (v: string) => v && (v + '').length <= 255 || 'Field must be less than 255 characters'
  ],
  number: [
    (v: string) => !isNaN(parseInt(v, 10)) || 'Field must be a number'
  ],
  email: [
    (v: string) => !v || /.+@.+/.test(v) || 'E-mail must be valid',
    (v: string) => !v || ('' + v).length <= 255 || 'Field must be less than 255 characters'
  ],
  password: [
    (v: string) => (!v || ('' + v).length >= 5) || 'Password must be longer than 5 characters',
    (v: string) => (!v || ('' + v).length <= 50) || 'Password must be less than 50 characters'
  ]
};

export const ORDER_CLARIFICATIONS = {
  orderNumber: `AX order number (SO; PO; LO; EO),
  Quantum number (MPO, MRO, MIN),
  Customer PO number or any other number, word, short sentence which describes this order.`,
  projectNumber: `Work order number (WO),
  Project number (PRJ, LM, BM).`,
  overallNotes: `shipping method (via DHL, TNT, Fedex, UPS etc.),
  account number,
  special requirements (dedicated van, two drivers, shipmet must include certificates / customer PO),
  latest date when the shipment is needed or some other overall note that Shipping / Stock team should know about the order`,
  itemDetails: `P/N, S/N, B/N,
  description, qty,
  value per line (if outside EU)`,
  shipperNotes: `opening hours,
  additional information about loading,
  special restrictions`,
  consigneeNotes: `opening hours,
  additional information about unloading,
  special restrictions`
} as {
  [key: string]: string
}

export const COUNTRIES: Country[] = [
  {zipRequired: false, EU: false, name: 'Afghanistan'},
  {zipRequired: false, EU: false, name: 'Albania'},
  {zipRequired: true, EU: false, name: 'Algeria'},
  {zipRequired: true, EU: false, name: 'Andorra'},
  {zipRequired: false, EU: false, name: 'Angola'},
  {zipRequired: false, EU: false, name: 'Anguilla'},
  {zipRequired: false, EU: false, name: 'Antigua and Barbuda'},
  {zipRequired: true, EU: false, name: 'Argentina'},
  {zipRequired: true, EU: false, name: 'Armenia'},
  {zipRequired: false, EU: false, name: 'Aruba'},
  {zipRequired: true, EU: false, name: 'Australia'},
  {zipRequired: true, EU: true, name: 'Austria'},
  {zipRequired: true, EU: false, name: 'Azerbaijan'},
  {zipRequired: false, EU: false, name: 'Bahamas'},
  {zipRequired: false, EU: false, name: 'Bahrain'},
  {zipRequired: true, EU: false, name: 'Bangladesh'},
  {zipRequired: false, EU: false, name: 'Barbados'},
  {zipRequired: true, EU: false, name: 'Belarus'},
  {zipRequired: true, EU: true, name: 'Belgium'},
  {zipRequired: false, EU: false, name: 'Belize'},
  {zipRequired: false, EU: false, name: 'Benin'},
  {zipRequired: false, EU: false, name: 'Bermuda'},
  {zipRequired: false, EU: false, name: 'Bhutan'},
  {zipRequired: false, EU: false, name: 'Bolivia'},
  {zipRequired: true, EU: false, name: 'Bosnia &amp; Herzegovina'},
  {zipRequired: false, EU: false, name: 'Botswana'},
  {zipRequired: true, EU: false, name: 'Brazil'},
  {zipRequired: true, EU: false, name: 'British Virgin Islands'},
  {zipRequired: true, EU: false, name: 'Brunei'},
  {zipRequired: true, EU: true, name: 'Bulgaria'},
  {zipRequired: false, EU: false, name: 'Burkina Faso'},
  {zipRequired: false, EU: false, name: 'Burundi'},
  {zipRequired: true, EU: false, name: 'Canada'},
  {zipRequired: true, EU: false, name: 'Cambodia'},
  {zipRequired: false, EU: false, name: 'Cameroon'},
  {zipRequired: false, EU: false, name: 'Cape Verde'},
  {zipRequired: true, EU: false, name: 'Cayman Islands'},
  {zipRequired: false, EU: false, name: 'Chad'},
  {zipRequired: false, EU: false, name: 'Chile'},
  {zipRequired: true, EU: false, name: 'China'},
  {zipRequired: true, EU: false, name: 'Colombia'},
  {zipRequired: false, EU: false, name: 'Congo'},
  {zipRequired: false, EU: false, name: 'Cook Islands'},
  {zipRequired: false, EU: false, name: 'Costa Rica'},
  {zipRequired: false, EU: false, name: 'Cote D Ivoire'},
  {zipRequired: true, EU: true, name: 'Croatia'},
  {zipRequired: true, EU: false, name: 'Cruise Ship'},
  {zipRequired: true, EU: false, name: 'Cuba'},
  {zipRequired: true, EU: true, name: 'Cyprus'},
  {zipRequired: true, EU: true, name: 'Czech Republic'},
  {zipRequired: true, EU: true, name: 'Denmark'},
  {zipRequired: false, EU: false, name: 'Djibouti'},
  {zipRequired: false, EU: false, name: 'Dominica'},
  {zipRequired: false, EU: false, name: 'Dominican Republic'},
  {zipRequired: true, EU: false, name: 'Ecuador'},
  {zipRequired: true, EU: false, name: 'Egypt'},
  {zipRequired: false, EU: false, name: 'El Salvador'},
  {zipRequired: false, EU: false, name: 'Equatorial Guinea'},
  {zipRequired: true, EU: true, name: 'Estonia'},
  {zipRequired: false, EU: false, name: 'Ethiopia'},
  {zipRequired: true, EU: false, name: 'Falkland Islands'},
  {zipRequired: true, EU: false, name: 'Faroe Islands'},
  {zipRequired: false, EU: false, name: 'Fiji'},
  {zipRequired: true, EU: true, name: 'Finland'},
  {zipRequired: true, EU: true, name: 'France'},
  {zipRequired: true, EU: false, name: 'French Polynesia'},
  {zipRequired: true, EU: false, name: 'French West Indies'},
  {zipRequired: false, EU: false, name: 'Gabon'},
  {zipRequired: false, EU: false, name: 'Gambia'},
  {zipRequired: true, EU: false, name: 'Georgia'},
  {zipRequired: true, EU: true, name: 'Germany'},
  {zipRequired: false, EU: false, name: 'Ghana'},
  {zipRequired: true, EU: false, name: 'Gibraltar'},
  {zipRequired: true, EU: true, name: 'Greece'},
  {zipRequired: true, EU: false, name: 'Greenland'},
  {zipRequired: false, EU: false, name: 'Grenada'},
  {zipRequired: true, EU: false, name: 'Guam'},
  {zipRequired: false, EU: false, name: 'Guatemala'},
  {zipRequired: true, EU: false, name: 'Guernsey'},
  {zipRequired: false, EU: false, name: 'Guinea'},
  {zipRequired: false, EU: false, name: 'Guinea Bissau'},
  {zipRequired: false, EU: false, name: 'Guyana'},
  {zipRequired: false, EU: false, name: 'Haiti'},
  {zipRequired: false, EU: false, name: 'Honduras'},
  {zipRequired: false, EU: false, name: 'Hong Kong'},
  {zipRequired: true, EU: true, name: 'Hungary'},
  {zipRequired: true, EU: false, name: 'Iceland'},
  {zipRequired: true, EU: false, name: 'India'},
  {zipRequired: true, EU: false, name: 'Indonesia'},
  {zipRequired: false, EU: false, name: 'Iran'},
  {zipRequired: true, EU: false, name: 'Iraq'},
  {zipRequired: false, EU: true, name: 'Ireland'},
  {zipRequired: true, EU: false, name: 'Isle of Man'},
  {zipRequired: true, EU: false, name: 'Israel'},
  {zipRequired: true, EU: true, name: 'Italy'},
  {zipRequired: false, EU: false, name: 'Jamaica'},
  {zipRequired: true, EU: false, name: 'Japan'},
  {zipRequired: true, EU: false, name: 'Jersey'},
  {zipRequired: false, EU: false, name: 'Jordan'},
  {zipRequired: true, EU: false, name: 'Kazakhstan'},
  {zipRequired: false, EU: false, name: 'Kenya'},
  {zipRequired: false, EU: false, name: 'Kuwait'},
  {zipRequired: true, EU: false, name: 'Kyrgyz Republic'},
  {zipRequired: false, EU: false, name: 'Laos'},
  {zipRequired: true, EU: true, name: 'Latvia'},
  {zipRequired: false, EU: false, name: 'Lebanon'},
  {zipRequired: false, EU: false, name: 'Lesotho'},
  {zipRequired: false, EU: false, name: 'Liberia'},
  {zipRequired: false, EU: false, name: 'Libya'},
  {zipRequired: true, EU: false, name: 'Liechtenstein'},
  {zipRequired: true, EU: true, name: 'Lithuania'},
  {zipRequired: true, EU: true, name: 'Luxembourg'},
  {zipRequired: false, EU: false, name: 'Macau'},
  {zipRequired: true, EU: false, name: 'Macedonia'},
  {zipRequired: true, EU: false, name: 'Madagascar'},
  {zipRequired: false, EU: false, name: 'Malawi'},
  {zipRequired: true, EU: false, name: 'Malaysia'},
  {zipRequired: true, EU: false, name: 'Maldives'},
  {zipRequired: false, EU: false, name: 'Mali'},
  {zipRequired: false, EU: true, name: 'Malta'},
  {zipRequired: false, EU: false, name: 'Mauritania'},
  {zipRequired: false, EU: false, name: 'Mauritius'},
  {zipRequired: true, EU: false, name: 'Mexico'},
  {zipRequired: true, EU: false, name: 'Moldova'},
  {zipRequired: true, EU: false, name: 'Monaco'},
  {zipRequired: true, EU: false, name: 'Mongolia'},
  {zipRequired: true, EU: false, name: 'Montenegro'},
  {zipRequired: false, EU: false, name: 'Montserrat'},
  {zipRequired: true, EU: false, name: 'Morocco'},
  {zipRequired: false, EU: false, name: 'Mozambique'},
  {zipRequired: false, EU: false, name: 'Namibia'},
  {zipRequired: false, EU: false, name: 'Nepal'},
  {zipRequired: true, EU: true, name: 'Netherlands'},
  {zipRequired: false, EU: false, name: 'Netherlands Antilles'},
  {zipRequired: true, EU: false, name: 'New Caledonia'},
  {zipRequired: true, EU: false, name: 'New Zealand'},
  {zipRequired: false, EU: false, name: 'Nicaragua'},
  {zipRequired: false, EU: false, name: 'Niger'},
  {zipRequired: false, EU: false, name: 'Nigeria'},
  {zipRequired: true, EU: false, name: 'Norway'},
  {zipRequired: false, EU: false, name: 'Oman'},
  {zipRequired: true, EU: false, name: 'Pakistan'},
  {zipRequired: true, EU: false, name: 'Palestine'},
  {zipRequired: false, EU: false, name: 'Panama'},
  {zipRequired: false, EU: false, name: 'Papua New Guinea'},
  {zipRequired: false, EU: false, name: 'Paraguay'},
  {zipRequired: false, EU: false, name: 'Peru'},
  {zipRequired: true, EU: false, name: 'Philippines'},
  {zipRequired: true, EU: true, name: 'Poland'},
  {zipRequired: true, EU: true, name: 'Portugal'},
  {zipRequired: true, EU: false, name: 'Puerto Rico'},
  {zipRequired: false, EU: false, name: 'Qatar'},
  {zipRequired: true, EU: false, name: 'Reunion'},
  {zipRequired: true, EU: false, name: 'Romania'},
  {zipRequired: true, EU: false, name: 'Russia'},
  {zipRequired: false, EU: false, name: 'Rwanda'},
  {zipRequired: true, EU: false, name: 'Saint Pierre &amp; Miquelon'},
  {zipRequired: false, EU: false, name: 'Samoa'},
  {zipRequired: true, EU: false, name: 'San Marino'},
  {zipRequired: true, EU: false, name: 'Satellite'},
  {zipRequired: false, EU: false, name: 'Saudi Arabia'},
  {zipRequired: false, EU: false, name: 'Senegal'},
  {zipRequired: true, EU: false, name: 'Serbia'},
  {zipRequired: false, EU: false, name: 'Seychelles'},
  {zipRequired: false, EU: false, name: 'Sierra Leone'},
  {zipRequired: true, EU: false, name: 'Singapore'},
  {zipRequired: true, EU: true, name: 'Slovakia'},
  {zipRequired: true, EU: true, name: 'Slovenia'},
  {zipRequired: false, EU: false, name: 'South Africa'},
  {zipRequired: true, EU: false, name: 'South Korea'},
  {zipRequired: true, EU: true, name: 'Spain'},
  {zipRequired: false, EU: false, name: 'Sri Lanka'},
  {zipRequired: true, EU: false, name: 'St Kitts &amp; Nevis'},
  {zipRequired: false, EU: false, name: 'St Lucia'},
  {zipRequired: false, EU: false, name: 'St Vincent'},
  {zipRequired: false, EU: false, name: 'St. Lucia'},
  {zipRequired: false, EU: false, name: 'Sudan'},
  {zipRequired: false, EU: false, name: 'Suriname'},
  {zipRequired: true, EU: false, name: 'Swaziland'},
  {zipRequired: true, EU: true, name: 'Sweden'},
  {zipRequired: true, EU: false, name: 'Switzerland'},
  {zipRequired: false, EU: false, name: 'Syria'},
  {zipRequired: true, EU: false, name: 'Taiwan'},
  {zipRequired: true, EU: false, name: 'Tajikistan'},
  {zipRequired: false, EU: false, name: 'Tanzania'},
  {zipRequired: true, EU: false, name: 'Thailand'},
  {zipRequired: false, EU: false, name: 'Timor L\'Este'},
  {zipRequired: false, EU: false, name: 'Togo'},
  {zipRequired: false, EU: false, name: 'Tonga'},
  {zipRequired: true, EU: false, name: 'Trinidad &amp; Tobago'},
  {zipRequired: true, EU: false, name: 'Tunisia'},
  {zipRequired: true, EU: false, name: 'Turkey'},
  {zipRequired: true, EU: false, name: 'Turkmenistan'},
  {zipRequired: false, EU: false, name: 'Turks &amp; Caicos'},
  {zipRequired: false, EU: false, name: 'Uganda'},
  {zipRequired: true, EU: false, name: 'Ukraine'},
  {zipRequired: false, EU: false, name: 'United Arab Emirates'},
  {zipRequired: true, EU: false, name: 'United Kingdom'},
  {zipRequired: true, EU: false, name: 'United States'},
  {zipRequired: false, EU: false, name: 'Uruguay'},
  {zipRequired: true, EU: false, name: 'Uzbekistan'},
  {zipRequired: false, EU: false, name: 'Venezuela'},
  {zipRequired: false, EU: false, name: 'Vietnam'},
  {zipRequired: true, EU: false, name: 'Virgin Islands (US)'},
  {zipRequired: false, EU: false, name: 'Yemen'},
  {zipRequired: false, EU: false, name: 'Zambia'},
  {zipRequired: false, EU: false, name: 'Zimbabwe'}
];
export const CURRENCIES = [
  {code: 'AED', symbol: 'د.إ;', name: 'UAE dirham'},
  {code: 'AFN', symbol: 'Afs', name: 'Afghan afghani'},
  {code: 'ALL', symbol: 'L', name: 'Albanian lek'},
  {code: 'AMD', symbol: 'AMD', name: 'Armenian dram'},
  {code: 'ANG', symbol: 'NAƒ', name: 'Netherlands Antillean gulden'},
  {code: 'AOA', symbol: 'Kz', name: 'Angolan kwanza'},
  {code: 'ARS', symbol: '$', name: 'Argentine peso'},
  {code: 'AUD', symbol: '$', name: 'Australian dollar'},
  {code: 'AWG', symbol: 'ƒ', name: 'Aruban florin'},
  {code: 'AZN', symbol: 'AZN', name: 'Azerbaijani manat'},
  {code: 'BAM', symbol: 'KM', name: 'Bosnia and Herzegovina konvertibilna marka'},
  {code: 'BBD', symbol: 'Bds$', name: 'Barbadian dollar'},
  {code: 'BDT', symbol: '৳', name: 'Bangladeshi taka'},
  {code: 'BGN', symbol: 'BGN', name: 'Bulgarian lev'},
  {code: 'BHD', symbol: '.د.ب', name: 'Bahraini dinar'},
  {code: 'BIF', symbol: 'FBu', name: 'Burundi franc'},
  {code: 'BMD', symbol: 'BD$', name: 'Bermudian dollar'},
  {code: 'BND', symbol: 'B$', name: 'Brunei dollar'},
  {code: 'BOB', symbol: 'Bs.', name: 'Bolivian boliviano'},
  {code: 'BRL', symbol: 'R$', name: 'Brazilian real'},
  {code: 'BSD', symbol: 'B$', name: 'Bahamian dollar'},
  {code: 'BTN', symbol: 'Nu.', name: 'Bhutanese ngultrum'},
  {code: 'BWP', symbol: 'P', name: 'Botswana pula'},
  {code: 'BYR', symbol: 'Br', name: 'Belarusian ruble'},
  {code: 'BZD', symbol: 'BZ$', name: 'Belize dollar'},
  {code: 'CAD', symbol: '$', name: 'Canadian dollar'},
  {code: 'CDF', symbol: 'F', name: 'Congolese franc'},
  {code: 'CHF', symbol: 'Fr.', name: 'Swiss franc'},
  {code: 'CLP', symbol: '$', name: 'Chilean peso'},
  {code: 'CNY', symbol: '¥', name: 'Chinese/Yuan renminbi'},
  {code: 'COP', symbol: 'Col$', name: 'Colombian peso'},
  {code: 'CRC', symbol: '₡', name: 'Costa Rican colon'},
  {code: 'CUC', symbol: '$', name: 'Cuban peso'},
  {code: 'CVE', symbol: 'Esc', name: 'Cape Verdean escudo'},
  {code: 'CZK', symbol: 'Kč', name: 'Czech koruna'},
  {code: 'DJF', symbol: 'Fdj', name: 'Djiboutian franc'},
  {code: 'DKK', symbol: 'Kr', name: 'Danish krone'},
  {code: 'DOP', symbol: 'RD$', name: 'Dominican peso'},
  {code: 'DZD', symbol: 'د.ج', name: 'Algerian dinar'},
  {code: 'EEK', symbol: 'KR', name: 'Estonian kroon'},
  {code: 'EGP', symbol: '£', name: 'Egyptian pound'},
  {code: 'ERN', symbol: 'Nfa', name: 'Eritrean nakfa'},
  {code: 'ETB', symbol: 'Br', name: 'Ethiopian birr'},
  {code: 'EUR', symbol: '€', name: 'European Euro'},
  {code: 'FJD', symbol: 'FJ$', name: 'Fijian dollar'},
  {code: 'FKP', symbol: '£', name: 'Falkland Islands pound'},
  {code: 'GBP', symbol: '£', name: 'British pound'},
  {code: 'GEL', symbol: 'GEL', name: 'Georgian lari'},
  {code: 'GHS', symbol: 'GH₵', name: 'Ghanaian cedi'},
  {code: 'GIP', symbol: '£', name: 'Gibraltar pound'},
  {code: 'GMD', symbol: 'D', name: 'Gambian dalasi'},
  {code: 'GNF', symbol: 'FG', name: 'Guinean franc'},
  {code: 'GQE', symbol: 'CFA', name: 'Central African CFA franc'},
  {code: 'GTQ', symbol: 'Q', name: 'Guatemalan quetzal'},
  {code: 'GYD', symbol: 'GY$', name: 'Guyanese dollar'},
  {code: 'HKD', symbol: 'HK$', name: 'Hong Kong dollar'},
  {code: 'HNL', symbol: 'L', name: 'Honduran lempira'},
  {code: 'HRK', symbol: 'kn', name: 'Croatian kuna'},
  {code: 'HTG', symbol: 'G', name: 'Haitian gourde'},
  {code: 'HUF', symbol: 'Ft', name: 'Hungarian forint'},
  {code: 'IDR', symbol: 'Rp', name: 'Indonesian rupiah'},
  {code: 'ILS', symbol: '₪', name: 'Israeli new sheqel'},
  {code: 'INR', symbol: '₹', name: 'Indian rupee'},
  {code: 'IQD', symbol: 'د.ع', name: 'Iraqi dinar'},
  {code: 'IRR', symbol: 'IRR', name: 'Iranian rial'},
  {code: 'ISK', symbol: 'kr', name: 'Icelandic króna'},
  {code: 'JMD', symbol: 'J$', name: 'Jamaican dollar'},
  {code: 'JOD', symbol: 'JOD', name: 'Jordanian dinar'},
  {code: 'JPY', symbol: '¥', name: 'Japanese yen'},
  {code: 'KES', symbol: 'KSh', name: 'Kenyan shilling'},
  {code: 'KGS', symbol: 'сом', name: 'Kyrgyzstani som'},
  {code: 'KHR', symbol: '៛', name: 'Cambodian riel'},
  {code: 'KMF', symbol: 'KMF', name: 'Comorian franc'},
  {code: 'KPW', symbol: 'W', name: 'North Korean won'},
  {code: 'KRW', symbol: 'W', name: 'South Korean won'},
  {code: 'KWD', symbol: 'KWD', name: 'Kuwaiti dinar'},
  {code: 'KYD', symbol: 'KY$', name: 'Cayman Islands dollar'},
  {code: 'KZT', symbol: 'T', name: 'Kazakhstani tenge'},
  {code: 'LAK', symbol: 'KN', name: 'Lao kip'},
  {code: 'LBP', symbol: '£', name: 'Lebanese lira'},
  {code: 'LKR', symbol: 'Rs', name: 'Sri Lankan rupee'},
  {code: 'LRD', symbol: 'L$', name: 'Liberian dollar'},
  {code: 'LSL', symbol: 'M', name: 'Lesotho loti'},
  {code: 'LTL', symbol: 'Lt', name: 'Lithuanian litas'},
  {code: 'LVL', symbol: 'Ls', name: 'Latvian lats'},
  {code: 'LYD', symbol: 'LD', name: 'Libyan dinar'},
  {code: 'MAD', symbol: 'MAD', name: 'Moroccan dirham'},
  {code: 'MDL', symbol: 'MDL', name: 'Moldovan leu'},
  {code: 'MGA', symbol: 'FMG', name: 'Malagasy ariary'},
  {code: 'MKD', symbol: 'MKD', name: 'Macedonian denar'},
  {code: 'MMK', symbol: 'K', name: 'Myanma kyat'},
  {code: 'MNT', symbol: '₮', name: 'Mongolian tugrik'},
  {code: 'MOP', symbol: 'P', name: 'Macanese pataca'},
  {code: 'MRO', symbol: 'UM', name: 'Mauritanian ouguiya'},
  {code: 'MUR', symbol: 'Rs', name: 'Mauritian rupee'},
  {code: 'MVR', symbol: 'Rf', name: 'Maldivian rufiyaa'},
  {code: 'MWK', symbol: 'MK', name: 'Malawian kwacha'},
  {code: 'MXN', symbol: '$', name: 'Mexican peso'},
  {code: 'MYR', symbol: 'RM', name: 'Malaysian ringgit'},
  {code: 'MZM', symbol: 'MTn', name: 'Mozambican metical'},
  {code: 'NAD', symbol: 'N$', name: 'Namibian dollar'},
  {code: 'NGN', symbol: '₦', name: 'Nigerian naira'},
  {code: 'NIO', symbol: 'C$', name: 'Nicaraguan córdoba'},
  {code: 'NOK', symbol: 'kr', name: 'Norwegian krone'},
  {code: 'NPR', symbol: 'NRs', name: 'Nepalese rupee'},
  {code: 'NZD', symbol: 'NZ$', name: 'New Zealand dollar'},
  {code: 'OMR', symbol: 'OMR', name: 'Omani rial'},
  {code: 'PAB', symbol: 'B./', name: 'Panamanian balboa'},
  {code: 'PEN', symbol: 'S/.', name: 'Peruvian nuevo sol'},
  {code: 'PGK', symbol: 'K', name: 'Papua New Guinean kina'},
  {code: 'PHP', symbol: '₱', name: 'Philippine peso'},
  {code: 'PKR', symbol: 'Rs.', name: 'Pakistani rupee'},
  {code: 'PLN', symbol: 'zł', name: 'Polish zloty'},
  {code: 'PYG', symbol: '₲', name: 'Paraguayan guarani'},
  {code: 'QAR', symbol: 'QR', name: 'Qatari riyal'},
  {code: 'RON', symbol: 'L', name: 'Romanian leu'},
  {code: 'RSD', symbol: 'din.', name: 'Serbian dinar'},
  {code: 'RUB', symbol: 'R', name: 'Russian ruble'},
  {code: 'SAR', symbol: 'SR', name: 'Saudi riyal'},
  {code: 'SBD', symbol: 'SI$', name: 'Solomon Islands dollar'},
  {code: 'SCR', symbol: 'SR', name: 'Seychellois rupee'},
  {code: 'SDG', symbol: 'SDG', name: 'Sudanese pound'},
  {code: 'SEK', symbol: 'kr', name: 'Swedish krona'},
  {code: 'SGD', symbol: 'S$', name: 'Singapore dollar'},
  {code: 'SHP', symbol: '£', name: 'Saint Helena pound'},
  {code: 'SLL', symbol: 'Le', name: 'Sierra Leonean leone'},
  {code: 'SOS', symbol: 'Sh.', name: 'Somali shilling'},
  {code: 'SRD', symbol: '$', name: 'Surinamese dollar'},
  {code: 'SYP', symbol: 'LS', name: 'Syrian pound'},
  {code: 'SZL', symbol: 'E', name: 'Swazi lilangeni'},
  {code: 'THB', symbol: '฿', name: 'Thai baht'},
  {code: 'TJS', symbol: 'TJS', name: 'Tajikistani somoni'},
  {code: 'TMT', symbol: 'm', name: 'Turkmen manat'},
  {code: 'TND', symbol: 'DT', name: 'Tunisian dinar'},
  {code: 'TRY', symbol: 'TRY', name: 'Turkish new lira'},
  {code: 'TTD', symbol: 'TT$', name: 'Trinidad and Tobago dollar'},
  {code: 'TWD', symbol: 'NT$', name: 'New Taiwan dollar'},
  {code: 'TZS', symbol: 'TZS', name: 'Tanzanian shilling'},
  {code: 'UAH', symbol: 'UAH', name: 'Ukrainian hryvnia'},
  {code: 'UGX', symbol: 'USh', name: 'Ugandan shilling'},
  {code: 'USD', symbol: 'US$', name: 'United States dollar'},
  {code: 'UYU', symbol: '$U', name: 'Uruguayan peso'},
  {code: 'UZS', symbol: 'UZS', name: 'Uzbekistani som'},
  {code: 'VEB', symbol: 'Bs', name: 'Venezuelan bolivar'},
  {code: 'VND', symbol: '₫', name: 'Vietnamese dong'},
  {code: 'VUV', symbol: 'VT', name: 'Vanuatu vatu'},
  {code: 'WST', symbol: 'WS$', name: 'Samoan tala'},
  {code: 'XAF', symbol: 'CFA', name: 'Central African CFA franc'},
  {code: 'XCD', symbol: 'EC$', name: 'East Caribbean dollar'},
  {code: 'XDR', symbol: 'SDR', name: 'Special Drawing Rights'},
  {code: 'XOF', symbol: 'CFA', name: 'West African CFA franc'},
  {code: 'XPF', symbol: 'F', name: 'CFP franc'},
  {code: 'YER', symbol: 'YER', name: 'Yemeni rial'},
  {code: 'ZAR', symbol: 'R', name: 'South African rand'},
  {code: 'ZMK', symbol: 'ZK', name: 'Zambian kwacha'},
  {code: 'ZWR', symbol: 'Z$', name: 'Zimbabwean dollar'}
];

export function isEmptyObject(obj: any) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
